// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__21JM6","header":"PatientBlock_header__2HoMj","label":"PatientBlock_label__2ZT_b","option":"PatientBlock_option__2L5n7"};